import { ReactElement } from "react";
import HubShopDetails from "../../../components/Hubs/Shops/details";
import Layout from "../../../components/layout";

const HubShopDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <HubShopDetails />
    </Layout>
  );
};

export default HubShopDetailsPage;
